import React, { useMemo } from 'react';
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap';
import PageReview from './PageReview';
import { groupPagesForResults } from '../../../utils';

import styles from './ParticipantResults.module.scss';

function ParticipantResponses({ participant, assessmentDocument, responses }) {
  const { capabilityPages, standardPages } = useMemo(
    () => groupPagesForResults(assessmentDocument.pages),
    [assessmentDocument.pages]
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h3" className={styles['participant-name']}>
          {participant.name}
        </CardTitle>
      </CardHeader>
      <CardBody>
        {[...capabilityPages, ...standardPages].map((page) => {
          return (
            <PageReview key={page.guid} page={page} responses={responses} />
          );
        })}
      </CardBody>
    </Card>
  );
}

export default ParticipantResponses;
